export default "__VITE_ASSET__CYE3nCht__"